var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-div"},[_c('div',{staticClass:"title-div"},[_vm._v(_vm._s(_vm.newsData.title))]),_c('div',{staticClass:"content-div"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.newsData.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }